<template>
  <div>
    <chart v-for="(item, index) in chartList" :key="index" :chartName="item.name" :chartType="item.type" :chartStyle="item.style" :chartData="item.data"></chart>
        <div v-if="statData && statData.latestImages && statData.latestImages.length > 0"
         class="latest-images-card"
         :style="{top: imagesTop + 'px', height: imagesHeight + 'px'}">

      <!-- 外层容器：隐藏溢出 -->
      <div class="marquee-wrap">
        <!-- 内层滚动容器 -->
        <div class="images-grid" ref="marqueeBox">
          <div v-for="(img, index) in imgList" :key="index" class="image-item">
            <img :src="img.image_url" class="preview-image" @click="previewImage(img.image_url)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from './chart'
export default {
  props: {
    statData: {
      type: Object,
      default: null
    },
    config: {
      type: Object,
      default: null
    }
  },
  components: { chart: Chart },
  data() {
    return {
      chartList: [],
      imagesTop: 0,
      imagesHeight: 0
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    statData() {
      this.chartList = []
      setTimeout(() => {
        this.init()
      }, 50)
    }
  },
  // 新增：计算属性，保证无缝循环
  computed: {
    imgList() {
      const list = this.statData?.latestImages || []
      // 无缝跑马灯必须：复制 2 份以上
      return [...list, ...list, ...list]
    }
  },
  methods: {
    init() {
      if (!this.statData) return
      // 你的原有逻辑不变，全部保留
      const dailyTop = this.config.head.height + this.config.space * 2
      const dailyHeight = this.config.height - this.config.head.height - this.config.unit - this.config.space * 4
      this.imagesTop = dailyTop + dailyHeight + this.config.space
      this.imagesHeight = this.config.height - this.imagesTop - 10

      // 下面你所有的 chartList.push 都完全不变
      this.chartList.push({
        name: 'aiResultData',
        type: 'pie',
        style: {
          left: this.config.space + 'px',
          top: this.config.space + 'px',
          height: this.config.unit + 'px',
          width: this.config.unit + 'px'
        },
        data: {
          title: 'AI审核结果',
          pie: { radius: '50%' },
          color: ['#67c23a', '#f56c6c'],
          data: this.statData.aiResultData
        }
      })

      this.chartList.push({
        name: 'locationRankData',
        type: 'bar',
        style: {
          left: this.config.space + 'px',
          top: this.config.unit + this.config.space * 2 + 'px',
          height: this.config.unit + 'px',
          width: this.config.unit + 'px'
        },
        data: {
          title: '地点平均得分排行TOP10',
          color: ['#fa6e72'],
          data: this.statData.locationRankData
        }
      })

      this.chartList.push({
        name: 'taskStatusData',
        type: 'pie',
        style: {
          right: this.config.space + 'px',
          top: this.config.space + 'px',
          height: this.config.unit + 'px',
          width: this.config.unit + 'px'
        },
        data: {
          title: '任务状态分布',
          pie: { radius: ['25%', '55%'] },
          color: ['#909399', '#e6a600', '#67c23a'],
          data: this.statData.taskStatusData
        }
      })

      this.chartList.push({
        name: 'workerRankData',
        type: 'bar',
        style: {
          right: this.config.space + 'px',
          top: this.config.unit + this.config.space * 2 + 'px',
          height: this.config.unit + 'px',
          width: this.config.unit + 'px'
        },
        data: {
          title: '工人平均得分排行TOP10',
          color: ['#1890ff'],
          data: this.statData.workerRankData
        }
      })

      this.chartList.push({
        name: 'dailyTaskData',
        type: 'bar',
        style: {
          top: this.config.head.height + this.config.space * 2 + 'px',
          left: this.config.unit + this.config.space * 2 + 'px',
          height: this.config.height - this.config.head.height - this.config.unit - this.config.space * 4 + 'px',
          width: (this.config.width - this.config.unit * 2 - this.config.space * 4) + 'px'
        },
        data: {
          title: this.statData.month
            ? `${this.statData.year}年${this.statData.month}月 每日任务统计`
            : `${this.statData.year}年 月度任务统计`,
          color: ['#0067bb', '#67c23a', '#f56c6c'],
          data: this.statData.dailyTaskData
        }
      })
    },
    previewImage(url) {
      this.$lgh.previewImage([url], 0)
    }
  }
}
</script>

<style lang="less" scoped>
.latest-images-card {
  position: absolute;
  left: 5px;
  width: calc(100% - 10px);
  background-color: #282839;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden; /* 关键 */
}

/* 跑马灯外层：固定宽度，隐藏溢出 */
.marquee-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 滚动容器：横向排列 + 动画 */
.images-grid {
  display: flex;
  gap: 10px;
  align-items: center;
  height: 100%;
  width: max-content; /* 关键：让容器自适应内容宽度 */
  animation: marquee 100s linear infinite; /* 速度可自己改 */

  &:hover {
    animation-play-state: paused; /* 鼠标悬停暂停 */
  }

  .image-item {
    flex: 0 0 auto;
    height: 100%;

    .preview-image {
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}

/* 真正无缝动画：平移 一整份图片的宽度 */
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% / 3)); /* 因为我们复制了3份，移动1份宽度就无缝 */
  }
}
</style>
